import { render, staticRenderFns } from "./HeroThree.vue?vue&type=template&id=0935312b&"
import script from "./HeroThree.vue?vue&type=script&lang=js&"
export * from "./HeroThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports